import camo from './camo';
import classic from './classic';
import modern from './modern';
import patriotic from './patriotic';
import pro from './pro';
import vintage from './vintage';

export const hockey = {
  classic,
  vintage,
  modern,
  pro,
  patriotic,
  camo,
};
